import React, { useState,  useRef, useEffect } from "react";
import {
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { deleteErpService } from "./ERPActions/erpActions";
import { EDIT_SERVICE } from "../../core/constants/erpConstants";
import Autocomplete from "@mui/material/Autocomplete";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import CheckIcon from "@mui/icons-material/Check";
import Close from "@mui/icons-material/Close";
import { PROCEDURE_CONSTANTS_DETAILS } from "../../shared/constants";

export default function AddServiceCard({
  addShow,
  addNewService,
  serviceForm,
  setAddNewService,
  setServiceForm,
  doctorList,
  handleAdd,
  handleCancelAdd,
  handleEditSuccess,
  isaddDisable,
  isServiceEdit,
}) {


  const descriptionRef = useRef(null);

useEffect(() => {
  // focus only when not package
  if (!addNewService.typePackage && descriptionRef.current) {
    descriptionRef.current.focus();
  }
}, [addNewService.typePackage]);


  const { quantity, originalAmount, discountAmount, editamount, doctor } =
    serviceForm;

  const [amountError, setAmountError] = useState("");

  if (!addShow || !addNewService || !addNewService.productDetail) return null;

  const handleAddClick = () => {
    // if (originalAmount === 0) {
    //   setAmountError("Amount cannot be 0");
    //   return;
    // }
    setAmountError("");
    handleAdd(); // only call original handler if valid
  };
  const handleEditClick1 = async () => {
    const pd = addNewService.productDetail;
    const patientId = pd.patientId;
    const visitId = pd.visitId;
    const soId = pd.soId;
    const soLinID = pd.soLinID;

    try {
      const resCb = await deleteErpService(patientId, visitId, soId, soLinID);

      if (resCb) {
        console.log("resCb proc add Response:", resCb);
        // fetchSalesOrder(false);
        handleAddClick();
      }
    } catch (err) {
      console.error("Failed to delete:", err);
    }

    console.log("deleted procedure");
  };

  const handleEditClick = async () => {
    const pd = addNewService.productDetail;

    const payload = {
      patientId: addNewService.patientId,
      visitId: addNewService.visitId,

      categoryId: pd.packageid,
      categoryServiceId: pd.packageServiceId,
      packageService: pd,

      quantity: serviceForm.quantity,
      gvid: serviceForm.doctor || "",
      refGvId: serviceForm.doctor || "",

      notes: addNewService.description || addNewService.serviceName,

      productId: addNewService.prodId || pd.productId,

      billAmount: serviceForm.editamount,
      originalServicePrice: serviceForm.originalAmount,

      billNumber: addNewService.billNumber || null,
      billDate: null,
      compositionId: null,
      billtype: "self",
      billable: true,
      soId: addNewService.soId,
      soLineId: addNewService.soLinID,
      groupname: PROCEDURE_CONSTANTS_DETAILS.PROCEDURE_GROUPNAME_INVOICE,
      subgroup: PROCEDURE_CONSTANTS_DETAILS.PROCEDURE_SUBGROUP_SO,
    };

    const patientId = pd.patientId;
    const visitId = pd.visitId;
    const soId = pd.soId;
    const soLinID = pd.soLinID;

    try {
      const resCb = await deleteErpService(
        patientId,
        visitId,
        soId,
        soLinID,
        EDIT_SERVICE,
        payload
      );

      console.log("Edit successful:", resCb);
      await handleEditSuccess();
      handleCancelAdd();
    } catch (err) {
      console.error("edit failed:", err);
    }
    // handleAdd();
  };
  return (
    <Card
      elevation={2}
      sx={{
        m: 2,
        borderRadius: 2,
        overflow: "hidden",
        position: "relative",
        overflowX: "auto",
      }}
    >
      {/* <IconButton
                        onClick={() => setAddShow(false)}
                        size="small"
                        sx={{
                            position: 'absolute',
                            top: -15,
                            right: -20,
                            zIndex: 2,
                            backgroundColor: '#fff',
                            borderRadius: '50%',
                            boxShadow: 2,
                            color: '#555',
                            '&:hover': {
                            color: '#000',
                            backgroundColor: '#f0f0f0',
                            },
                        }}
                        >
                        <CloseIcon fontSize="small" />
                        </IconButton> */}
      <CardContent
        sx={{
          p: 0,
          "&:last-child": { pb: 0 },
        }}
      >
        <Table
          size="small"
          sx={{
            m: 0,
            p: 0,
            "& th": {
              fontWeight: 600,
              textAlign: "center",
              backgroundColor: "#f5f5f5",
              color: "#333",
            },
            "& td": {
              textAlign: "center",
              verticalAlign: "middle",
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>Service</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Original Charges /per unit</TableCell>
              <TableCell>Discount Charges /per unit</TableCell>
              <TableCell>Qty</TableCell>
              {addNewService &&
                addNewService.productDetail.isDoctor === "true" && (
                  <TableCell>Doctor</TableCell>
                )}
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                {addNewService.serviceName}
                {addNewService.typePackage &&
                  Array.isArray(addNewService.serviceList) && (
                    <>
                      {addNewService.serviceList.map((service, idx) => (
                        <div
                          key={idx}
                          className="align-items-center"
                          style={{
                            fontSize: "0.85rem",
                            color: "#555",
                            alignItems: "center",
                          }}
                        >
                          {service.serviceName}
                        </div>
                      ))}
                    </>
                  )}
              </TableCell>
              <TableCell>
                {addNewService.typePackage ? (
                  <>{addNewService.description}</>
                ) : (
                  <TextField
                    inputRef={descriptionRef}
                    value={addNewService.description || ""}
                    onChange={(e) =>
                      setAddNewService({
                        ...addNewService,
                        description: e.target.value,
                      })
                    }
                  />
                )}
                {/* {addNewService.productDetail.description} */}
              </TableCell>
              <TableCell sx={{ verticalAlign: "top", pt: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    type="number"
                    size="small"
                    value={originalAmount}
                    onChange={(e) => {
                      const value = formatDecimal(e.target.value, 2);
                      setServiceForm((prev) => ({
                        ...prev,
                        originalAmount: value,
                        editamount: value - prev.discountAmount,
                      }));
                    //   if (value !== 0) setAmountError(""); // clear error when valid
                     setAmountError("");
                    }}
                    inputProps={{
                      min: 0,
                      // readOnly: addNewService.originalPrice !== 0,
                    }}
                    sx={{
                      width: 100,
                      "& .MuiOutlinedInput-root": {
                        height: "40px",
                        fontSize: "0.9rem",
                      },
                      "& .MuiFormHelperText-root": {
                        margin: "2px 0 0 0",
                        fontSize: "0.75rem",
                        lineHeight: "1rem",
                        textAlign: "center",
                        whiteSpace: "nowrap", // ✅ keeps text in one line
                      },
                    }}
                    error={!!amountError}
                    helperText={amountError}
                  />
                </Box>
              </TableCell>

              {/* )} */}
              {/* <TableCell>
                      <TextField
                        type="number"
                        size="small"
                        value={editamount}
                        onChange={(e) => setEditAmount(Number(e.target.value))}
                        inputProps={{
                          min: 0,
                          readOnly: addNewService.price !== 0,
                        }}
                        sx={{ width: 100 }}
                      />
                    </TableCell> */}
              <TableCell>
                <TextField
                  type="number"
                  size="small"
                  value={discountAmount}
                  onChange={(e) => {
                    const value = formatDecimal(e.target.value, 2);
                    setServiceForm((prev) => {
                      if (value > prev.originalAmount) {
                        return prev;
                      }

                      return {
                        ...prev,
                        discountAmount: value,
                        editamount: prev.originalAmount - value,
                      };
                    });
                  }}
                  inputProps={{
                    min: 0,
                    // readOnly: addNewService.price !== 0,
                  }}
                  sx={{ width: 100 }}
                />
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  size="small"
                  value={quantity}
                  onChange={(e) => {
                    const value = formatDecimal(e.target.value, 0);
                    setServiceForm((prev) => ({
                      ...prev,
                      quantity: value,
                    }));
                  }}
                  inputProps={{ min: 1 }}
                  sx={{ width: 70 }}
                />
              </TableCell>
              {addNewService &&
                addNewService.productDetail.isDoctor === "true" && (
                  <TableCell>
                    <Autocomplete
                      options={doctorList}
                      getOptionLabel={(option) => option.label || ""}
                      value={
                        doctorList.find((doc) => doc.gvId === doctor) || null
                      }
                      onChange={(e, newValue) =>
                        setServiceForm((prev) => ({
                          ...prev,
                          doctor: newValue ? newValue.gvId : "",
                        }))
                      }
                      disabled={addNewService.productDetail.gvId > 0}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Doctor"
                          size="small"
                          sx={{
                            "& .MuiInputBase-root": {
                              height: 43,
                            },
                            "& .MuiInputBase-input": {
                              padding: "4px 8px",
                            },
                            "& label": {
                              fontSize: 13,
                            },
                          }}
                        />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      sx={{
                        minWidth: 180,
                        // '& .MuiAutocomplete-inputRoot': {
                        //   padding: '0px !important',
                        // },
                        // '& .MuiAutocomplete-endAdornment': {
                        //   top: 'calc(50% - 14px)'
                        // },
                      }}
                      disableClearable
                    />
                  </TableCell>
                )}

              <TableCell>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {isServiceEdit ? (
                    <IconButton
                      onClick={handleEditClick}
                      size="small"
                      color="primary"
                      sx={{ p: 0.5 }}
                      disabled={isaddDisable}
                    >
                      <CheckIcon fontSize="small" />
                    </IconButton>
                  ) : (
                    <IconButton
                      onClick={handleAddClick}
                      size="small"
                      color="primary"
                      sx={{ p: 0.5 }}
                      disabled={isaddDisable}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  )}
                  <IconButton
                    onClick={() => handleCancelAdd()}
                    size="small"
                    sx={{
                      p: 0.5,
                      ml: 1,
                      color: "#888",
                      "&:hover": {
                        color: "#d32f2f",
                      },
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              </TableCell>

              {/* {(!isServiceEdit)&&(
              <TableCell>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    onClick={handleAddClick}
                    size="small"
                    color="primary"
                    sx={{ p: 0.5 }}
                    disabled={isaddDisable}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    onClick={() => handleCancelAdd()}
                    size="small"
                    sx={{
                      p: 0.5,
                      ml: 1,
                      color: "#888",
                      "&:hover": {
                        color: "#d32f2f",
                      },
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              </TableCell>
              )} */}
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
// export const allowNumericWithDecimal = (e, decimalDigits = 2) => {
//   const { key, target } = e;

//   // numbers
//   if (/^[0-9]$/.test(key)) return;

//   // allow 1 decimal point
//   if (key === "." && !target.value.includes(".")) return;

//   // allow backspace, delete, arrows, tab
//   if (["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(key))
//     return;

//   // enforce decimal limit
//   if (target.value.includes(".") && key !== "Backspace") {
//     const decimals = target.value.split(".")[1];
//     if (decimals && decimals.length >= decimalDigits) {
//       e.preventDefault();
//       return;
//     }
//   }

//   e.preventDefault();
// };

export const formatDecimal = (value, decimalDigits = 2) => {
  if (value === null || value === undefined || value === "") return 0;

  const num = Number(value);
  if (isNaN(num)) return 0;

  if (decimalDigits === 0) {
    return Math.floor(num);
  }

  return Number(num.toFixed(decimalDigits));
};
